import { Dialog, Grid, Link, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getDesign } from "../../../api/caseApi";
import { StyledButton } from "../../../common/components/Button";
import { middleEllipsisText } from "../../../common/helpers/middleEllipsisText";
import { API_URL } from "../../../config";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import {
  DialogHeader,
  FileDetails,
  FilesStack,
  Note,
  SectionTitle,
} from "../styles";
import ApproveDesignDialog from "./ApproveDesignDialog";
import RejectDesignDialog from "./RejectDesignDialog";
import { CircularProgress } from "@mui/material";
import { grey } from "@mui/material/colors";
const ReviewDesignDialog = ({ caseId, open, onClose, patientName }) => {
  const [design, setDesign] = useState();
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    if (open === false) {
      return;
    }

    const fetchDesign = async () => {
      const { data } = await getDesign(caseId);
      console.log(data.data);
      data.data.files.sort(function (a, b) {
        return new Date(a.createdDate) - new Date(b.createdDate);
      });
      setDesign(data.data);
    };

    fetchDesign();

    return () => {
      setDesign(undefined);
    };
  }, [caseId, open]);

  const [isDialogOpen, setIsDialogOpen] = useState({
    approveDesign: false,
    rejectDesign: false,
  });

  const handleDownloadAll = async () => {
    let zip = new JSZip();
    setIsDownloading(true);
    for (const file of design.files) {
      const response = await fetch(API_URL + `file/${file.id}/download`);
      let blob = await response.blob();
      zip.file(file.fileName, blob);
    }

    zip.generateAsync({ type: "blob" }).then(function (content) {
      saveAs(content, patientName + "_DesignFiles");
    });
    setIsDownloading(false);
  };

  const handleDialogOpenClick = (dialogName) => {
    setIsDialogOpen((prev) => ({ ...prev, [dialogName]: true }));
  };

  const handleDialogCloseClick = (dialogName) => {
    setIsDialogOpen((prev) => ({ ...prev, [dialogName]: false }));
    onClose();
  };

  if (design === undefined) {
    return null;
  }

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <Dialog open={isDownloading}>
        <Box sx={{ paddingX: 10, paddingY: 10 }}>
          <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
          <Typography sx={{ marginTop: 4, color: grey[600] }}>
            Please wait while we process your request.
          </Typography>
        </Box>
      </Dialog>
      <Box sx={{ paddingX: 3, paddingY: 2 }}>
        <DialogHeader>Review the Design</DialogHeader>
        <Box sx={{ marginBottom: 2, marginTop: 2 }}>
          <StyledButton theme="green" onClick={handleDownloadAll}>
            Download All Files
          </StyledButton>
          <FilesStack
            direction="row"
            spacing={1}
            style={{ overflowX: "scroll", WebkitOverflowScrolling: "touch" }}
          >
            {design.files.map((file) => (
              <FileDetails>
                <Typography>{middleEllipsisText(file.fileName)}</Typography>
                <Link
                  href={API_URL + `file/${file.id}/download`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download
                </Link>
              </FileDetails>
            ))}
          </FilesStack>
        </Box>

        <Grid container rowSpacing={2} sx={{ marginBottom: 2 }}>
          <Grid item xs={1}>
            <SectionTitle>Link</SectionTitle>
          </Grid>
          <Grid item xs={11}>
            <Box sx={{ height: "100%", display: "flex", alignItems: "center" }}>
              <Link
                href={design.designLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {design.designLink}
              </Link>
            </Box>
          </Grid>

          <Grid item xs={1}>
            <SectionTitle>Note</SectionTitle>
          </Grid>
          <Grid item xs={11}>
            <Note>{design.note}</Note>
          </Grid>
        </Grid>

        <Box sx={{ display: "flex" }}>
          <Box sx={{ marginLeft: "auto" }}>
            <StyledButton
              theme="purple"
              onClick={() => handleDialogOpenClick("rejectDesign")}
            >
              Reject
            </StyledButton>
            <StyledButton
              theme="green"
              sx={{ marginLeft: 1.5 }}
              onClick={() => handleDialogOpenClick("approveDesign")}
            >
              Approve
            </StyledButton>
          </Box>
        </Box>
      </Box>
      <ApproveDesignDialog
        caseId={caseId}
        open={isDialogOpen.approveDesign}
        onClose={() => handleDialogCloseClick("approveDesign")}
      />
      <RejectDesignDialog
        caseId={caseId}
        open={isDialogOpen.rejectDesign}
        onClose={() => handleDialogCloseClick("rejectDesign")}
      />
    </Dialog>
  );
};

export default ReviewDesignDialog;
